////////////////////////////////////////////////////////////////////////////////
// Country
////////////////////////////////////////////////////////////////////////////////

class Contact extends Pages {

	// ===========================================================================
	// Constructor
	// ===========================================================================

	constructor(entry) {
		super(entry)
	}

	// ===========================================================================
	// Initialisation
	// ===========================================================================

	/**
	 * The entry needs to be passed in here so that this class can update the data
	 * used for this class instance. Otherwise it will always stay the same no matter
	 * what page you go to nest.
	 * @param  {Object} entry
	 */

	init(entry) {
		this.update.entry(entry)
	}

	// ===========================================================================
	// Load In
	// ===========================================================================

	/**
	 * This is run when navigating to a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	in(content, done) {

		// If the button used to get to the contact page has a data-behaviour attribute
		// on it (normally a 'call to action' button), then we will run through a bunch 
		// of validation and checks to ensure the bahavour matches the value of one of
		// the contact form types. If it does, pre-populate the radio field.

		if ( this.element && this.element.hasAttribute("data-behaviour") && this.element.getAttribute("data-behaviour") != '') {
			let behaviour = this.element.getAttribute("data-behaviour")
			let main = Object.values(content).find(node => node.nodeName == 'MAIN')

			if ( main ) {
				let radios = main.querySelectorAll('form.contactForm input[type="radio"]')
				if ( radios.length ) {
					let radio = Object.values(radios).find(node => node.value == behaviour )
					if ( radio ) {
						radio.checked = true
					}
				}
			}
		}

		// 
		//
		// fetcher.get('/fetch-template', { template : '/_forms/contact.twig' }, {
		// 	success : (response) => {
		//
		// 		console.log(response)
		//
		// 		// let articles = $(response.html).filter('.article')
		// 		//
		// 		// articlesList.append(articles)
		// 		// Scroll.to(articles.first(), -32)
		// 		//
		// 		// TweenMax.set(articles, page.transition.in.from)
		// 		// TweenMax.staggerTo(articles, 0.5, page.transition.in.to, 0.2)
		// 		//
		// 		// historyAPI.loading = false
		// 		//
		// 		// let newOffset = offset + articles.length
		// 		//
		// 		// if ( newOffset >= total ) {
		// 		// 	button.addClass('loaded').text('No More Articles')
		// 		// 	console.log(`all ${total} are listed`)
		// 		// } else {
		// 		// 	articlesList.attr('data-offset', offset + articles.length)
		// 		// 	console.log(`showing ${newOffset} of ${total}`)
		// 		// }
		// 	},
		// 	error : (response) => {
		//
		// 		console.error('error', response)
		//
		// 	}
		// })


		page.in(content, done)

	}

	// ===========================================================================
	// Load Out
	// ===========================================================================

	/**
	 * This is run when navigating awat from a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	out(content, done) {

    page.out(content, done)

	}

}
